<template>
  <v-checkbox
    :class="$style.checkbox"
    v-bind="$attrs"
    v-on="$listeners"
    color="accent darken-3"
    :ripple="false"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-checkbox>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Checkbox extends Vue {
}
</script>

<style module lang="scss">
.checkbox {

  &:hover {
    :global(.v-icon) {
      color: $primary_base;
    }
  }

  :global(.v-label) {
    color: $primary_darken1;
  }

  :global(.v-icon) {
    color: $primary_lighten2;
  }

  // active

  &:global(.v-input--is-label-active) {
    &:hover {
      :global(.v-icon) {
        color: $accent_darken1 !important;
      }
    }
  }

  &:global(.v-input--is-label-active) {
    &:focus,
    &:global(.v-input--is-focused) {
      :global(.v-icon) {
        color: $accent_darken2 !important;
      }
    }
  }

  // focus
  &:focus,
  &:global(.v-input--is-focused) {
    :global(.v-icon) {
      color: $accent_darken3
    }
  }

  // disabled
  &:global(.v-input--is-disabled) {
    :global(.v-icon),
    :global(.v-label) {
      color: $primary_lighten2 !important;
    }
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .checkbox {
    padding-top: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 28px;
  }
}
@media (max-width: 599px) {
  .checkbox {
    padding-top: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 28px;
  }
}

</style>
